import { render, staticRenderFns } from "./grid-col-item.vue?vue&type=template&id=27e5a4c4&scoped=true&"
import script from "./grid-col-item.vue?vue&type=script&lang=js&"
export * from "./grid-col-item.vue?vue&type=script&lang=js&"
import style0 from "./grid-col-item.vue?vue&type=style&index=0&id=27e5a4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e5a4c4",
  null
  
)

export default component.exports